import React, { memo } from 'react';

const BigLactation = memo(({ size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5212 51.3333C13.0006 51.3333 4.86523 50.957 4.86523 41.2222C4.86523 31.4874 14.5212 21.6021 14.5212 21.6021"
        stroke="#B3611A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5215 21.6021C14.5215 21.6021 24.2028 31.4874 24.2028 41.2222C24.2028 50.957 16.0421 51.3333 14.5215 51.3333"
        stroke="#B3611A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9258 48.3477C25.9258 48.3477 30.5383 51.3333 37.6853 51.3333C44.8322 51.3333 50.3825 44.4086 50.3825 36.2545"
        stroke="#B3611A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9824 4.66666C20.9824 4.66666 25.595 11.767 34.4146 17.0609C41.9417 21.6021 48.2522 26.4444 49.9249 32.8423"
        stroke="#B3611A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.9258 32.8423H49.9511C49.9511 32.8423 51.3704 33.1685 51.5224 34.2223C51.6492 35.3011 50.382 36.2545 50.382 36.2545"
        stroke="#B3611A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default BigLactation;
